import { Issue } from '@qality/common-model/src/Issue';
import StatusUtils from '@qality/common-utils/src/StatusUtils';

export default {
  formatJIRAIssueToIssue(
    issueFromJira?: Issue,
    getBrowseIssueUrl?: (projectKey: string) => string
  ): any {
    if (!issueFromJira) {
      return null;
    }

    return {
      issueId: issueFromJira.id,
      issueKey: issueFromJira.key,
      issueLink: getBrowseIssueUrl(issueFromJira.key),
      iconSrc: issueFromJira.fields?.issuetype?.iconUrl,
      title: issueFromJira.fields?.summary,
      ...(issueFromJira.fields?.status?.name
        ? {
            status: {
              name: issueFromJira.fields?.status?.name,
              // Lozenge appearance
              kind: StatusUtils.getAppearanceType(
                issueFromJira.fields?.status?.statusCategory?.colorName
              ),
            },
          }
        : null),
    };
  },
};
